import { TLink } from "@/components/molecules/Button";
import clsx from "clsx";

const Pager = ({ Pagination, Top, className }) => {
  return (
    <>
      <section
        className={clsx(
          className,
          "box-border flex w-full justify-between px-6 pt-6 md:px-8 md:pt-8 lg:pt-10"
        )}
      >
        <div className="--inactive text-lg font-bold">
          {/* <TLink variant="light" color="ff" href="#">
            PREV
          </TLink> */}
        </div>
        {Pagination && (
          <div className="flex flex-col items-center justify-center gap-0">
            <ul className="flex items-center justify-center gap-4">
              <li className="text-lg font-bold text-txt-light line-through">
                1
              </li>
              <li className="">
                <TLink
                  variant="light"
                  color="f"
                  href="#"
                  className="text-lg font-bold"
                >
                  2
                </TLink>
              </li>
              <li className="">
                <TLink
                  variant="light"
                  color="f"
                  href="#"
                  className="text-lg font-bold"
                >
                  3
                </TLink>
              </li>
            </ul>
            <p className="mt-2 rounded-full bg-gray-50 py-1 px-3 text-xs tracking-widest text-txt-light">
              1-20/94
            </p>
          </div>
        )}
        {Top && (
          <div className="text-lg font-bold text-txt-base">
            <TLink variant="light" color="ff" href="/">
              TOP
            </TLink>
          </div>
        )}
        <div className="--inactive text-lg font-bold text-txt-base">
          {/* <TLink variant="light" color="ff" href="#">
            NEXT
          </TLink> */}
        </div>
      </section>
    </>
  );
};

export default Pager;
